import { Building2, DollarSign, Activity, Target, TrendingUp } from 'lucide-react';

export const scoringCategories = {
  firmographic: {
    title: "Firmographic Data",
    weight: 25,
    icon: Building2,
    color: "bg-blue-500",
    attributes: [
      { name: "companySize", label: "Company Size (Employees)", points: { "1-10": 2, "11-50": 4, "51-200": 6, "201-1000": 8, "1000+": 10 } },
      { name: "revenue", label: "Annual Revenue", points: { "<$1M": 1, "$1M-$10M": 3, "$10M-$50M": 5, "$50M-$200M": 7, "$200M+": 10 } },
      { name: "industry", label: "Industry Fit", points: { "Low fit": 0, "Medium fit": 3, "High fit": 5 } },
      { name: "yearsInBusiness", label: "Years in Business", points: { "<1": 1, "1-3": 3, "3-10": 5, "10+": 5 } },
      { name: "location", label: "Geographic Location", points: { "Out of territory": 0, "Secondary market": 2, "Primary market": 5 } }
    ]
  },
  financial: {
    title: "Financial Health",
    weight: 20,
    icon: DollarSign,
    color: "bg-green-500",
    attributes: [
      { name: "creditScore", label: "Credit Score/Rating", points: { "Poor (<600)": 0, "Fair (600-699)": 3, "Good (700-749)": 6, "Excellent (750+)": 10 } },
      { name: "profitability", label: "Profitability Status", points: { "Losses": 1, "Break-even": 3, "Profitable": 7, "Highly profitable": 10 } },
      { name: "cashFlow", label: "Cash Flow Health", points: { "Negative": 0, "Neutral": 3, "Positive": 5 } },
      { name: "debtLevel", label: "Debt Level", points: { "High": 1, "Moderate": 3, "Low": 5 } }
    ]
  },
  engagement: {
    title: "Behavioral Engagement",
    weight: 20,
    icon: Activity,
    color: "bg-purple-500",
    attributes: [
      { name: "websiteVisits", label: "Website Visits (Last 30 days)", points: { "0": 0, "1-2": 2, "3-5": 4, "6-10": 6, "11+": 8 } },
      { name: "contentEngagement", label: "Content Downloads", points: { "None": 0, "1": 2, "2-3": 4, "4+": 6 } },
      { name: "emailEngagement", label: "Email Engagement", points: { "No opens": 0, "Opens only": 2, "Clicks": 4, "Replies": 6 } },
      { name: "demoRequest", label: "Demo/Trial Request", points: { "No": 0, "Yes": 10 } }
    ]
  },
  intent: {
    title: "Purchase Intent & Fit",
    weight: 25,
    icon: Target,
    color: "bg-orange-500",
    attributes: [
      { name: "timeline", label: "Purchase Timeline", points: { "No timeline": 0, ">12 months": 2, "6-12 months": 5, "3-6 months": 8, "<3 months": 10 } },
      { name: "budget", label: "Budget Status", points: { "No budget": 0, "Budget needed": 3, "Budget allocated": 10 } },
      { name: "authority", label: "Decision Maker Identified", points: { "No": 0, "Influencer": 3, "Decision maker": 8 } },
      { name: "need", label: "Need/Pain Level", points: { "Low": 1, "Medium": 4, "High": 7, "Critical": 10 } },
      { name: "competition", label: "Competitive Situation", points: { "Loyal to competitor": 0, "Evaluating options": 5, "Dissatisfied with current": 7 } }
    ]
  },
  strategic: {
    title: "Strategic Value",
    weight: 10,
    icon: TrendingUp,
    color: "bg-red-500",
    attributes: [
      { name: "ltv", label: "Lifetime Value Potential", points: { "Low": 1, "Medium": 3, "High": 7, "Very high": 10 } },
      { name: "referral", label: "Referral Source", points: { "Cold outbound": 1, "Inbound": 3, "Partner": 5, "Customer referral": 7 } },
      { name: "expansion", label: "Upsell/Cross-sell Potential", points: { "Low": 1, "Medium": 3, "High": 5 } },
      { name: "strategic", label: "Strategic Account Value", points: { "Standard": 0, "Important": 3, "Strategic": 5 } }
    ]
  }
};